export var GhccMessageType;
(function (GhccMessageType) {
    GhccMessageType["init"] = "Init";
    GhccMessageType["linkSpeed"] = "LinkSpeed";
    GhccMessageType["newPassport"] = "NewPassport";
    GhccMessageType["startActivity"] = "StartActivity";
    GhccMessageType["initializeActivity"] = "InitializeActivity";
    GhccMessageType["terminateActivity"] = "TerminateActivity";
})(GhccMessageType || (GhccMessageType = {}));
//# sourceMappingURL=ghccMessageTypes.js.map